export default {
  medications: {
    label: 'Medikamente',
    filterTitle: 'Nach Status filtern',
    search: 'Medikamente suchen',
    status: {
      draft: 'Entwurf',
      active: 'Aktiv',
      onHold: 'In Wartestellung',
      cancelled: 'Abgesagt',
      completed: 'Abgeschlossen',
      enteredInError: 'Fehlerhaft eingegeben',
      stopped: 'Gestoppt',
      unknown: 'Unbekannt',
    },
    intent: {
      proposal: 'Vorschlag',
      plan: 'Planen',
      order: 'Bestellung',
      originalOrder: 'Ursprüngliche Bestellung',
      reflexOrder: 'Reflexreihenfolge',
      fillerOrder: 'Füllauftrag',
      instanceOrder: 'Instanzbestellung',
      option: 'Möglichkeit',
    },
    priority: {
      routine: 'Routine',
      urgent: 'Dringend',
      asap: 'So schnell wie möglich',
      stat: 'Stat',
    },
    filter: {
      all: 'Alle Status',
    },
    requests: {
      label: 'Medikamentenanfragen',
      new: 'Medikamente anfordern',
      view: 'Medikamente anzeigen',
      cancel: 'Medikamente abbrechen',
      complete: 'Komplette Medikation',
      error: {
        unableToRequest: 'Medikationsanforderung kann nicht erstellt werden.',
        unableToComplete: 'Medikamentenanforderung kann nicht abgeschlossen werden.',
        quantityRequired: 'Menge ist erforderlich.',
        unitRequired: 'Einheit ist erforderlich.',
      },
    },
    medication: {
      medication: 'Medikament',
      for: 'Zum',
      status: 'Status',
      intent: 'Absicht',
      priority: 'Priorität',
      notes: 'Anmerkungen',
      quantity: 'Menge',
      quantityValue: 'Wert',
      quantityUnit: 'Einheit',
      requestedOn: 'Angefordert am',
      requestedBy: 'Angefordert von',
      completedOn: 'Vervollständigt am',
      canceledOn: 'Abgebrochen am',
      patient: 'Geduldig',
    },
  },
}
